import Select from "components/controls/Select";
import WorkBlock from "domain/WorkBlock";
import React from "react";

export default function WorkOrderSelect({ workOrders, onChange, workBlockLayout, disabled = false }) {
  const options = toOptions(workOrders, workBlockLayout);

  return (
    <Select
      className="spec-work-order-select"
      disabled={disabled}
      field="workOrder[id]"
      labelText="Work order"
      maxHeight="250"
      onChange={onChange}
      options={options}
    />
  );
}

function toOptions(workOrders, workBlockLayout) {
  return workOrders.map((workOrder) => {
    const { id, code } = workOrder;

    const description = WorkBlock.description({ workOrder }, workBlockLayout);
    let label = description ? `${description} • ` : "";
    label += code;

    return { label, value: id };
  });
}
